import React from 'react';
import { Provider } from "react-redux";
import { store, history } from "./store";
import Routes from "./router/index";

function App() {
  return (
    <div className="App">
      {/* <Header /> */}
      <Provider store={store}>
        <Routes history={history} />
      </Provider>
    </div>
  );
}

export default App;
